<template>
  <div class="col mb-30">
    <div class="product__items product__items2">
      <div class="product__items--thumbnail">
        <a class="product__items--link" href="#">
          <img
            class="product__items--img product__primary--img"
            src="/assets/img/product/categories10.png"
            alt="product-img"
            
          />
          <img
            class="product__items--img product__secondary--img"
            src="/assets/img/product/big-product2.jpg"
            alt="product-img"
          />
          <!-- <img
            class="product__items--img product__secondary--img"
            :src="product.images[1]"
            alt="product-img"
          /> -->
        </a>
        <div class="product__badge">
          <span class="product__badge--items sale">{{ product.status }}</span>
        </div>
        <ul class="product__items--action">
          <li class="product__items--action__list">
            <!-- <a class="product__items--action__btn" @click="ADD_PRODUCT_TO_CART(product, 1)" href="#"> -->
            <a class="product__items--action__btn" 
            :class="{ active: wishlistItems.some(wishItem => wishItem.id === product.id) }"
            @click="wishlistItems.some(wishItem => wishItem.id === product.id) ? removeFromWishlist() : addtoWishlist() " >
              <svg
                class="product__items--action__btn--svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  d="M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="32"
                />
              </svg>
              <span class="visually-hidden">Wishlist</span>
            </a>
          </li>
          <li class="product__items--action__list">
            <a
              class="product__items--action__btn"
              data-open="modal1"
              href="javascript:void(0)"
            >
              <svg
                class="product__items--action__btn--svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  d="M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z"
                  fill="none"
                  stroke="currentColor"
                  stroke-miterlimit="10"
                  stroke-width="32"
                />
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  stroke-width="32"
                  d="M338.29 338.29L448 448"
                />
              </svg>
              <span class="visually-hidden">Quick View</span>
            </a>
          </li>
          <li class="product__items--action__list">
            <a class="product__items--action__btn" href="#">
              <svg
                class="product__items--action__btn--svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="32"
                  d="M400 304l48 48-48 48M400 112l48 48-48 48M64 352h85.19a80 80 0 0066.56-35.62L256 256"
                />
                <path
                  d="M64 160h85.19a80 80 0 0166.56 35.62l80.5 120.76A80 80 0 00362.81 352H416M416 160h-53.19a80 80 0 00-66.56 35.62L288 208"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="32"
                />
              </svg>
              <span class="visually-hidden">Compare</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="product__items--content product__items2--content text-center">
        <a class="add__to--cart__btn" @click="cartItems.some(wishItem => wishItem.id === product.id) ? removeFromCart() : addtoCart() "> {{cartItems.some(cartItem => cartItem.id === product.id) ? '- Remove From Cart' : '+ Add to cart' }}</a>
        <h3 class="product__items--content__title h4">
          <a >{{ product.name }}</a>
        </h3>
        <div class="product__items--price">
          <span class="current__price"><sup>$</sup> {{ product.price }}</span>
          <span v-if="product.old_price || Number(product.old_price) > 0" class="old__price"><sup>$</sup> {{ product.old_price }}</span>
        </div>
        <div
          class="
            product__items--rating
            d-flex
            justify-content-center
            align-items-center
          "
        >
          <ul class="d-flex">
            <li class="product__items--rating__list">
              <span class="product__items--rating__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10.105"
                  height="9.732"
                  viewBox="0 0 10.105 9.732"
                >
                  <path
                    data-name="star - Copy"
                    d="M9.837,3.5,6.73,3.039,5.338.179a.335.335,0,0,0-.571,0L3.375,3.039.268,3.5a.3.3,0,0,0-.178.514L2.347,6.242,1.813,9.4a.314.314,0,0,0,.464.316L5.052,8.232,7.827,9.712A.314.314,0,0,0,8.292,9.4L7.758,6.242l2.257-2.231A.3.3,0,0,0,9.837,3.5Z"
                    transform="translate(0 -0.018)"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </li>
          </ul>
          <span class="product__items--rating__count--number">({{
            product.ratings
          }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "GridProductItem",
  props: {
    product: Object
  },
  computed: {
    ...mapGetters(["wishlistItems", "storeProducts", "cartItems"]),
  },
  methods: {
    ...mapActions(["ADD_PRODUCT_TO_CART", "ADD_PRODUCT_TO_WISHLIST", "REMOVE_FROM_CART", "REMOVE_FROM_WISHLIST"]),
    async convertImage(){
      let images = JSON.parse(this.product.images);
      this.product.images = images;
    },
    removeFromCart(){
        this.REMOVE_FROM_CART(this.product)
    },
    addtoCart(){
      this.ADD_PRODUCT_TO_CART({id: this.product.id, quantity: 1})
    },
    addtoWishlist(){
      this.ADD_PRODUCT_TO_WISHLIST(this.product)
    },
    removeFromWishlist(){
      console.log('removing from wishlist')
      this.REMOVE_FROM_WISHLIST(this.product)
    },
  },
  async created(){
    await this.convertImage();
  }
};
</script>